import React from 'react';
import { Button, Flex, FormControl, FormLabel, Input, Text, useToast } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { TOAST_SETTINGS, USER_TYPE } from '../../constants';
import { deleteMFAEnrollment } from '../../services/mfaService';
import Card from '../../components/Card';

const MfaAdmin = () => {
  const toast = useToast();
  const { user_details } = useSelector((state) => state.authentication);

  const [email, setEmail] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);

  const isSuperAdmin = user_details?.user_type_id === USER_TYPE.SUPER_ADMIN;

  const isValidEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };

  const handleSubmit = async () => {
    if (!isValidEmail(email)) {
      toast({
        ...TOAST_SETTINGS.SETTINGS,
        status: TOAST_SETTINGS.ERROR,
        title: 'Please enter a valid email address.',
      });
      return;
    }

    setIsLoading(true);

    try {
      const result = await deleteMFAEnrollment(email);

      if (result.ok) {
        toast({
          ...TOAST_SETTINGS.SETTINGS,
          status: TOAST_SETTINGS.SUCCESS,
          title: result.message || 'Success!',
        });
      } else {
        toast({
          ...TOAST_SETTINGS.SETTINGS,
          status: TOAST_SETTINGS.ERROR,
          title: result.error || 'Something went wrong.',
        });
      }
    } catch (error) {
      toast({
        ...TOAST_SETTINGS.SETTINGS,
        status: TOAST_SETTINGS.ERROR,
        title: 'Unexpected error occurred.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (!isSuperAdmin) {
    return (
      <Card style={{ padding: '16px 32px', marginTop: '16px' }}>
        <Text color="main.primary" fontWeight="800" fontSize="xl" mb={2}>
          MFA Administration
        </Text>
        <Text color="main.gray" fontSize="sm">
          Only SUPER ADMIN users can access the MFA page.
        </Text>
      </Card>
    );
  }

  return (
    <Card style={{ padding: '16px 32px', marginTop: '16px' }}>
      <Text color="main.primary" fontWeight="800" fontSize="xl" mb={4}>
        Reset MFA
      </Text>

      <Flex direction="column" maxW="600px">
        <FormControl id="mfa-email">
          <FormLabel>Email</FormLabel>
          <Input
            type="email"
            value={email}
            placeholder="admin@example.com"
            onChange={(e) => setEmail(e.target.value)}
            isDisabled={isLoading}
          />
        </FormControl>

        <Flex mt={4}>
          <Button
            bg="main.semiPrimary"
            color="main.white"
            _hover={{ bg: 'main.primary' }}
            _active={{ bg: 'main.semiPrimary', borderColor: 'main.primary' }}
            onClick={handleSubmit}
            isLoading={isLoading}
          >
            Submit
          </Button>
        </Flex>
      </Flex>
    </Card>
  );
};

export default MfaAdmin;
